/**
 * @file App-wide chrome: the browser banner above whatever the route renders.
 *
 * Consumers are `RootLayout` and the router's `errorElement`, which renders
 * outside `RootLayout` and needs the same shell. Holds the height invariant:
 * `#root` is `height: 100%`, so the outer column pins itself to `100%` and the
 * inner column takes the remainder through `FlexBox`'s `flexGrow: 1` — the
 * definite height a page's own `minHeight: 100%` resolves against. The outer
 * `noGap` drops the 10px `FlexCol` gap that would sit under the banner, and
 * `alignItems: 'stretch'` overrides `FlexCol`'s `flex-start` so pages rooted
 * in an antd `Layout`, which is `width: auto`, still fill the width.
 */
import { ReactNode } from 'react';

import FlexCol from '../components/atoms/FlexCol';
import { UnsupportedBrowserBanner } from '../browserSupport';

interface AppShellProps {
  children: ReactNode;
}

function AppShell({ children }: AppShellProps) {
  return (
    <FlexCol noGap style={{ alignItems: 'stretch', height: '100%' }}>
      <UnsupportedBrowserBanner />
      <FlexCol style={{ alignItems: 'stretch' }}>{children}</FlexCol>
    </FlexCol>
  );
}

export default AppShell;
